import { Menu, Transition } from '@headlessui/react'
import classNames from 'classnames'
import React, { Fragment } from 'react'
import { FeArrowDown, FeArrowUp } from '../../components/common/Icons'
import LinkLocale from '../../modules/i18n/LinkLocale'
import PromoBadge from '../promotion/landing/PromoBadge'

const LeftMenu: React.FC<any> = ({ navigation, onClickMenuHandler }) => {
  return navigation.map((item, i) => (
    <Fragment key={`menu-${item.label}`}>
      {item.noCursor ? (
        <div key={i} className="text-h4 mr-4 font-bold text-gray-700">
          {item.label}
        </div>
      ) : (
        <Menu key={i} as="div" className="relative ml-3">
          {({ open }) => (
            <>
              <Menu.Button className="flex items-center justify-center rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2">
                <div
                  onClick={() => onClickMenuHandler && onClickMenuHandler(item.eventId, item.label)}
                  className={classNames(
                    'text-h4 relative mr-4 font-bold hover:text-purple-500',
                    open ? 'text-purple-500' : 'text-gray-700'
                  )}
                >
                  {item.href ? <LinkLocale href={item.href}>{item.label}</LinkLocale> : item.label}
                  {item.showToolTip && (
                    /**
                     * 모바일용 PromoBadge
                     */
                    <div className="inline lg:hidden">
                      <PromoBadge />
                    </div>
                    // <StaticTooltip
                    //   text={promotionText}
                    //   bgDanger
                    //   isTop
                    //   style={{
                    //     fontSize: 12,
                    //     fontWeight: 500,
                    //     top: 8,
                    //     left: 3,
                    //   }}
                    // />
                  )}
                </div>
                <div>
                  {item?.menuArray?.length > 0 &&
                    (open ? (
                      <FeArrowUp size={14} className="ml-1 text-purple-500" />
                    ) : (
                      <FeArrowDown size={14} className="ml-1 text-gray-700" />
                    ))}
                </div>
              </Menu.Button>
              {item?.menuArray?.length > 0 && (
                <Transition
                  show={open}
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items
                    static
                    className="absolute left-0 top-56 mt-2 origin-top-right rounded-md bg-white p-16 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                  >
                    <div className="flex items-start">
                      {/* ENG일때 영문서 교정 제외 */}
                      {item?.menuArray
                        ?.filter((value) => value !== false)
                        .map((side, i) => (
                          <div key={i} className="flex w-[160px] flex-col">
                            <div className="text-h6 mb-11 text-gray-700">{side?.subMenuTitle}</div>
                            {side?.subMenu
                              ?.filter((e) => !e.none)
                              .map((subMenuItem) => {
                                return (
                                  <Menu.Item key={subMenuItem.label}>
                                    {({ active }) => (
                                      <LinkLocale
                                        href={subMenuItem.href}
                                        className={classNames(
                                          'text-h5 mb-4 block py-4 text-black hover:text-purple-500'
                                        )}
                                      >
                                        <div
                                          onClick={() =>
                                            onClickMenuHandler &&
                                            onClickMenuHandler(subMenuItem.eventId, subMenuItem.label)
                                          }
                                        >
                                          {subMenuItem.label}
                                        </div>
                                      </LinkLocale>
                                    )}
                                  </Menu.Item>
                                )
                              })}
                          </div>
                        ))}
                    </div>
                  </Menu.Items>
                </Transition>
              )}
            </>
          )}
        </Menu>
      )}
    </Fragment>
  ))
}

export default LeftMenu
